import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ArrowRightIcon } from 'lucide-react';
import { fbq } from '../App';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(299);
  const [spots, setSpots] = useState(12);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  useEffect(() => {
    const spotTimer = setInterval(() => {
      setSpots(prev => prev > 3 ? prev - 1 : prev);
    }, 45000);
    return () => clearInterval(spotTimer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  const handleClick = () => {
    fbq('track', 'AddToCart', {
      content_name: 'Social Hacker v1.0',
      content_type: 'product',
      value: 9.99,
      currency: 'USD'
    });
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };
  return <div className="sticky top-0 z-50 w-full bg-cyber-dark border-b border-cyber-neon/30 overflow-hidden cursor-pointer" onClick={handleClick} data-id="element-628">
      <motion.div className="absolute inset-0 bg-gradient-to-r from-cyber-red/15 via-cyber-neon/5 to-cyber-red/15" animate={{
      opacity: [0.3, 0.7, 0.3]
    }} transition={{
      duration: 1.5,
      repeat: Infinity
    }} data-id="element-629" />

      <div className="max-w-7xl mx-auto px-3 py-2.5 relative z-10 flex items-center justify-between gap-2" data-id="element-630">
        <div className="flex items-center gap-2 flex-1 min-w-0" data-id="element-631">
          <ZapIcon className="w-4 h-4 text-cyber-neon animate-pulse shrink-0" data-id="element-632" />
          <span className="text-cyber-neon font-mono text-xs sm:text-sm font-bold truncate" data-id="element-633">
            92% OFF vence en
          </span>
          <motion.span key={formattedTime} initial={{
          scale: 1.3
        }} animate={{
          scale: 1
        }} className="bg-cyber-black px-2 py-0.5 rounded border border-cyber-red text-cyber-red font-mono font-bold text-sm shadow-neon-red shrink-0" data-id="element-634">
            {formattedTime}
          </motion.span>
          <span className="text-gray-400 text-xs font-mono hidden sm:inline" data-id="element-635">
            — Quedan <span className="text-cyber-neon font-bold" data-id="element-636">{spots}</span>{' '}
            accesos
          </span>
        </div>

        <motion.div whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-cyber-neon text-cyber-black font-mono font-bold text-xs px-3 py-1.5 rounded flex items-center gap-1 shrink-0 shadow-neon" data-id="element-637">
          COMPRAR <ArrowRightIcon className="w-3 h-3" data-id="element-638" />
        </motion.div>
      </div>
    </div>;
}